import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: []
}

export const productSlice = createSlice({
  name: 'productSliceName',
  initialState,
  reducers: {
    addProduct: (state) => {
      state.loading = true;
      state.error = null;
    },
    getProduct: (state) => {
      state.loading = true;
      state.error = null;
    },
    getOneProduct: (state) => {
      state.loading = true;
      state.error = null;
    },

    successProduct: (state, action) => {
      state.loading = false;
      state.error = null;
      state.data = action.payload
  },
    failedProduct: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    removeProduct: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateProduct: (state) => {
      state.loading = true;
      state.error = null;
    },
    emptyCart: (state, action) => {
      state.value += action.payload
    },
    searchProductByName:(state)=>{
      state.loading = true;
      state.error = null;
    }
  },
})

// Action creators are generated for each case reducer function
export const { addProduct, removeProduct, updateProduct, getProduct, successProduct, failedProduct, getOneProduct, searchProductByName } = productSlice.actions

export default productSlice.reducer
